import React from 'react';
import { Check, CircleAlert, Loader2 } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { cn } from '@/lib/utils';

interface AutoSaveIndicatorProps {
  status: 'idle' | 'saving' | 'saved' | 'error';
  lastSavedAt: Date | null;
  className?: string;
}

export const AutoSaveIndicator: React.FC<AutoSaveIndicatorProps> = ({
  status,
  lastSavedAt,
  className,
}) => {
  if (status === 'idle' && !lastSavedAt) {
    return null;
  }

  if (status === 'saving') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 text-sm text-gray-600',
          className
        )}
        aria-live="polite"
      >
        <Loader2 className="w-4 h-4 animate-spin" />
        Salvando...
      </span>
    );
  }

  if (status === 'error') {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 text-sm text-red-600',
          className
        )}
        aria-live="polite"
      >
        <CircleAlert className="w-4 h-4" />
        Erro ao salvar
      </span>
    );
  }

  if (status === 'idle' && lastSavedAt) {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1.5 text-sm text-gray-500',
          className
        )}
      >
        Alterações pendentes
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-sm text-gray-500',
        className
      )}
      aria-live="polite"
    >
      <Check className="w-4 h-4 text-green-600" />
      Conteúdo salvo com sucesso
      {lastSavedAt ? ` · ${format(lastSavedAt, 'HH:mm', { locale: ptBR })}` : ''}
    </span>
  );
};
